
import AppHeader from '@/components/Header.vue'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Fault-SaveBillSuccess',
  components: {
    AppHeader,
  },
  methods: {
    toList(): void {
      this.$router.replace({ name: 'fault-list' })
    },
  },
})
